// extracted by mini-css-extract-plugin
export default {"root":"newsTranslation_root__YOIVk"};